var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortHighlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.56036 9.26651L5.09567 12.8018L8.63098 9.26651C8.98633 8.91116 9.56036 8.91116 9.91572 9.26651C10.2711 9.62187 10.2711 10.1959 9.91572 10.5513L5.73348 14.7335C5.37813 15.0888 4.8041 15.0888 4.44875 14.7335L0.266515 10.5513C-0.0888383 10.1959 -0.0888383 9.62187 0.266515 9.26651C0.621868 8.92027 1.20501 8.91116 1.56036 9.26651Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62176 5.73349L5.08646 2.19818L1.55115 5.73348C1.1958 6.08884 0.621764 6.08884 0.266412 5.73348C-0.0889415 5.37813 -0.0889415 4.8041 0.266412 4.44875L4.44864 0.266514C4.804 -0.0888386 5.37803 -0.0888385 5.73338 0.266514L9.91561 4.44875C10.271 4.8041 10.271 5.37813 9.91561 5.73349C9.56026 6.07973 8.97712 6.08884 8.62176 5.73349Z",
    fill: "#9D9FA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortHighlight);
export default __webpack_public_path__ + "static/media/sort-highlight.4c6b8c525c6bc7c42bdad3f05622b9db.svg";
export { ForwardRef as ReactComponent };